import React, {useRef} from "react";
import {Row, Space} from "antd";
import HighchartsReact from 'highcharts-react-official';
import {skipToken} from "@reduxjs/toolkit/query";
import {useSelector} from "react-redux";
import {selectOptions} from "../../../redux/features/optionsSlice";
import Highcharts from "highcharts";
import {useBankBranchChartsParamsContext} from "../../../context/BankBranchChartsContext";
import {useGetBBBTotalNegotiationsQuery} from "../../../redux/api/chartsApiSlice";
import BBBChartCardContainer from "../BBBChartCardContainer";
import {selectUser} from "../../../redux/features/userSlice";

export default function TotalBankBranchesNegotiations() {
    const ref = useRef<HighchartsReact.RefObject>(null);
    const {params} = useBankBranchChartsParamsContext()
    const uwYear = useSelector(selectUser).preferences?.charts_params?.uw_year
    const isCommonParamsOk = !!(params.budget_group && params.bank_branch_uuid && typeof uwYear === 'number')

    const {data, isFetching, isUninitialized} = useGetBBBTotalNegotiationsQuery(isCommonParamsOk ? {
                uw_year: uwYear,
                entity: 1,
                entity_uuid: params.bank_branch_uuid,
                budget_group: params.budget_group,
                calculation_type: 1,
                negotiations_type: 3,
            } : skipToken
    )

    const lastIndex = data?.history.length ? data?.history.length - 1 : undefined
    const previousYearsData = data && typeof lastIndex === 'number' ? data?.history.slice(0, lastIndex) : []
    const currentYearData = data && typeof lastIndex === 'number' ? data.history[lastIndex] : undefined
    const options = useSelector(selectOptions)

    const values: number[] = []
    const colors: string[] = []
    const categories: string[] = []

    data?.result.forEach(el => {
        const state = options.states.find(state => state.value === el.state)
        if (state) {
            values.push(el.amount)
            colors.push(state.color)
            categories.push(state.text)
        }
    })

    return <BBBChartCardContainer loading={isFetching || isUninitialized}>
        <Row justify={"space-between"}>
            <h2>Trattative totali</h2>
            <Space>
                {previousYearsData.map(el => <div key={el.year}>
                    {el.year}: <strong>{el.amount}</strong>
                </div>)}
            </Space>
        </Row>
        {!!currentYearData && <Row justify={"end"}>
            <div style={{fontSize: "18px"}}>
                {currentYearData?.year}: <strong>{currentYearData?.amount}</strong>
            </div>
        </Row>}
        <HighchartsReact
            highcharts={Highcharts}
            ref={ref}
            options={{
                chart: {
                    type: 'column',
                    height: "45%"
                },
                title: {
                    text: ''
                },
                subtitle: {
                    text: ""
                },
                legend: {
                    enabled: false
                },
                exporting: {
                    enabled: false
                },
                credits: undefined,
                xAxis: {
                    categories,
                    crosshair: true,
                    accessibility: {
                        description: 'Countries'
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: ''
                    },
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0,
                        borderRadius: 5,
                        colorByPoint: true,
                        dataLabels: {
                            enabled: true,
                            format: '{point.y}',
                        }
                    }
                },
                series: [
                    {
                        name: 'Trattative',
                        data: values,
                        colors
                    }
                ]
            }}
        />
    </BBBChartCardContainer>
}